import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';
import { DeDupScope } from './analytical-settings';
import { ExportStream } from './export-stream';

export enum ProjectState {
    UNKNOWN = 'UNKNOWN',
    AVAILABLE = 'AVAILABLE',
    WARNING = 'WARNING',
    FAILURE = 'NOT_AVAILABLE',
    NOT_LICENSED = 'NOT_LICENSED',
    DEACTIVATED = 'DEACTIVATED'
}
export enum ProjectActivationState {
    ACTIVE = 'ACTIVE',
    DELETE_PENDING = 'DELETE_PENDING',
    DEACTIVATED = 'DEACTIVATED',
    DISABLED = 'DISABLED',
    DELETE_REQUEST_PENDING = 'DELETE_REQUEST_PENDING',
    IMPORTING = 'IMPORTING',
    IMPORT_FAILED = 'IMPORT_FAILED'
}

export enum ProjectAction {
    APPROVE_PROJECT_DELETION = 'Approve Project Deletion'
}

export class ProjectViewModel extends DrObject {

    model: Partial<Project>;

    constructor(value?: Partial<Project>) {
        super(DrObjectType.PROJECT);

        if (value) {
            this.model = value;
        }
    }
}

export class Project extends DrEntity {
    name: string;
    description: string;
    dateCreated: string;
    userName: string;
    // TODO: type: string;
    projectState: ProjectState;
    projectActivationState: ProjectActivationState;
    orgName: string;
    projectServiceName: string;
    lastAccessed: string;
    projectGuid: string;
    deDupScope: DeDupScope;

    tlsDefaultExportStreamHandle: string;
    tlsDefaultExportStream: ExportStream;
    tlsDefaultTag: string;
    isTlsExpress: boolean;
    reviewProjectId: number = 0;
    reviewSystem: string;

    projectAction: ProjectAction;
    projectHandle: string;
    reviewProjects: any[];
    defaultReviewProjectDto: any;
    selfServiceProject: boolean;

    constructor(value?: Partial<Project>) {
        super(value);
        if (value) {
            Object.assign(this, value);
            if (value.reviewProjects?.length > 0) {
                this.reviewSystem = value.reviewProjects[0].reviewSystem;
                this.reviewProjectId = value.reviewProjects[0].reviewProjectId;
            }
        }
    }
}
